import { enqueueSnackbar } from 'notistack';

const displayErrorMessage = (message: string) => enqueueSnackbar(message, { variant: 'error' });

export default displayErrorMessage;
